import { useEffect, useState } from "react";
import { UTSLocale } from "@smile2impress/attraction-constants";

import {
    BookingConfirmationType,
    fetchAttractionClinics,
} from "../api/location";
import { getCookiesValueByName } from "../utils/cookie";
import { COOKIES } from "../constants/enum";

export enum SMSVerificationRequiredSetUpType {
    SMS_VERIFICATION_REQUIRED_SET_UP_OFF = "0",
    SMS_VERIFICATION_REQUIRED_SET_UP_ON = "1",
}

export const verificationRequiredByQueryParam = (
    cookieName: string = COOKIES.IS_SMS_VERIFICATION_REQUIRED_SET_UP
) => {
    const smsVerificationCookieValue = getCookiesValueByName(cookieName);

    if (
        Object.values(SMSVerificationRequiredSetUpType).includes(
            smsVerificationCookieValue as SMSVerificationRequiredSetUpType
        )
    ) {
        return Boolean(Number(smsVerificationCookieValue));
    }

    return null;
};

export const useIsSmsVerificationRequired = ({
    clinicId,
}: {
    clinicId?: number | null;
    locale?: UTSLocale;
}) => {
    const hasWindow = typeof window !== "undefined";
    const [isSMSRequired, setIsSMSRequired] = useState<boolean>(false);

    useEffect(() => {
        if (!clinicId) {
            setIsSMSRequired(false);
            return;
        }

        // SMS verification query param should have highest priority
        const verificationFromCookie = verificationRequiredByQueryParam();
        if (verificationFromCookie !== null) {
            setIsSMSRequired(verificationFromCookie);
            return;
        }

        fetchAttractionClinics({
            confirmationType: BookingConfirmationType.SMS,
        })
            .then(({ data }) => {
                const clinicsIDs = data.items?.map(({ id }) => id) || [];
                setIsSMSRequired(clinicsIDs.includes(clinicId));
            })
            .catch(() => {
                setIsSMSRequired(false);
            });
    }, [clinicId, hasWindow]);

    return { isSMSRequired };
};
